import { INPUT } from '$gbusiness/enums';
import { input } from '$gbusiness/helpers';
import InputRowModel from '$gbusiness/models/inputRow';

const ECOMMERCE_SETTINGS_FORM = (): Array<InputRowModel> => [
  {
    items: [
      {
        label: 'SCREEN.ECOMMERCE.COLS.AUTHNET_API_LOGIN',
        value: 'ecommerce.aznet.aznet1',
        input: INPUT.TEXT,
        gridSize: 12,
        validation: [input.requiredValidation],
      },
      {
        label: 'SCREEN.ECOMMERCE.COLS.AUTHNET_TRANS_KEY',
        value: 'ecommerce.aznet.aznet2',
        input: INPUT.TEXT,
        gridSize: 12,
        validation: [input.requiredValidation],
      },
    ],
  },
];

export default ECOMMERCE_SETTINGS_FORM;
